module.exports = __webpack_public_path__ + "img/hybrid.9e70f78d.jpg";